import React from 'react';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CommonAppBarAdmin = ({
  leftGap = '60px',
  top = 63,
  section,
  height,
  onBack,
  title,
}) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${leftGap})`,
        ml: leftGap,
        top,
        backgroundColor: '#fff',
        color: '#333',
        boxShadow: '0px 0px 0px 0px #fff',
        zIndex: 15,
        height: height ? height : 55,
      }}>
      <Toolbar
        sx={{
          minHeight: 'auto',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 1,
          py: 1.5,
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}>
          <IconButton
            size="small"
            sx={{ color: '#333' }}
            onClick={onBack}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
            gap: 2,
          }}>
          {section}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default CommonAppBarAdmin;
